import { getClientDownloads as getDownloadsFromConfig, ClientDownloads } from '../utils/config';

export type ClientPlatform = 'windows' | 'macos' | 'android' | 'ios';

export function getClientDownloads(): ClientDownloads {
  return getDownloadsFromConfig();
}

export function getClientDownloadUrl(platform: ClientPlatform): string | undefined {
  const downloads = getClientDownloads();
  const url = downloads[platform]?.url;
  if (!url || !url.startsWith('http')) return undefined;
  return url;
}

/** macOS 安装后解除隔离的命令 */
export function getMacQuarantineCommand(): string {
  const appName = getClientDownloads().macos.appName || 'NodeUnion.app';
  return `xattr -rd com.apple.quarantine /Applications/${appName}`;
}
